<div
  cdkDrag
  cdkDragBoundary=".cdk-overlay-container"
  cdkDragRootElement=".cdk-overlay-pane"
  class="featureDetailsContainer not-see-through"
>
  <ng-template [ngIf]="dsaInit" [ngIfThen]="dsaContainer"></ng-template>
  <ng-template [ngIf]="!dsaInit" [ngIfThen]="presenceContainer"></ng-template>
</div>

<ng-template #dsaContainer>
  <div class="device-container" cdkDragHandle>
    <div class="axonDevicePopoutHeader">
      <ng-container *ngIf="data.marker.bannerContent.length">
        <div class="notifications">
          <ng-container *ngFor="let content of displayedIcons; let i = index">
            <fs-axon-notification-icon
              [content]="content"
              (click)="$event.stopPropagation()"
            ></fs-axon-notification-icon>
          </ng-container>
        </div>
      </ng-container>
      <div class="dragAndName">
        <ng-container
          *ngIf="isUnitDetailsBetaEnabled() && dsaAssignee.internalId; else noUnitDetail"
        >
          <div class="officerCallsign">
            <span>
              {{ dsaAssignee.internalId }}
            </span>
          </div>
          <div class="officerCallsign">
            <span>
              {{ dsaAssignee.internalId }}
            </span>
          </div>
          <div class="officerNameSmall">
            {{ dsaAssignee.firstName + ' ' + dsaAssignee.lastName }}
          </div>
        </ng-container>
        <ng-template #noUnitDetail>
          <div class="officerName">
            <span>
              {{ data.marker.device.deviceName }}
            </span>
          </div>
        </ng-template>
      </div>
      <div class="actionButtons">
        <button mat-icon-button (click)="dockCamera()" matTooltip="Dock Camera">
          <sn-icon fontSet="fal" fontIcon="fa-video"></sn-icon>
        </button>
        <button
          *ngIf="!data.marker.getFollowMode()"
          mat-icon-button
          (click)="setFollowMode()"
          matTooltip="Follow Marker"
        >
          <sn-icon fontSet="fs" fontIcon="Icon_Tether"></sn-icon>
        </button>
        <button
          *ngIf="data.marker.getFollowMode()"
          mat-icon-button
          (click)="stopFollowMode()"
          matTooltip="Stop Following"
        >
          <sn-icon fontSet="fal" fontIcon="fa-ban"></sn-icon>
        </button>
        <button mat-icon-button color="warn" matTooltip="Close" (click)="this.close()">
          <sn-icon fontSet="far" fontIcon="fa-xmark"></sn-icon>
        </button>
      </div>
    </div>
    <div *ngIf="data.marker.getFollowMode()" class="following-msg">Currently Following</div>
    <fs-axon-livestream-iframe
      [device]="data.marker.device"
      [marker]="data.marker"
      [isDocked]="false"
    ></fs-axon-livestream-iframe>
  </div>
</ng-template>

<ng-template #presenceContainer>
  <div class="device-container" cdkDragHandle>
    <div class="axonDevicePopoutHeader">
      <ng-container *ngIf="data.marker.bannerContent.length">
        <div class="notifications">
          <ng-container *ngFor="let content of displayedIcons; let i = index">
            <fs-axon-notification-icon
              [content]="content"
              (click)="$event.stopPropagation()"
            ></fs-axon-notification-icon>
          </ng-container>
        </div>
      </ng-container>
      <div class="dragAndName">
        <div class="officerName">
          <span>
            {{ data.marker.device.deviceName }}
          </span>
        </div>
      </div>
      <div class="actionButtons">
        <button mat-icon-button (click)="dockCamera()" matTooltip="Dock Camera">
          <sn-icon fontSet="fal" fontIcon="fa-video"></sn-icon>
        </button>
        <button
          *ngIf="!data.marker.getFollowMode()"
          mat-icon-button
          (click)="setFollowMode()"
          matTooltip="Follow Marker"
        >
          <sn-icon fontSet="fs" fontIcon="Icon_Tether"></sn-icon>
        </button>
        <button
          *ngIf="data.marker.getFollowMode()"
          mat-icon-button
          (click)="stopFollowMode()"
          matTooltip="Stop Following"
        >
          <sn-icon fontSet="fal" fontIcon="fa-ban"></sn-icon>
        </button>
        <button mat-icon-button color="warn" matTooltip="Close" (click)="this.close()">
          <sn-icon fontSet="far" fontIcon="fa-xmark"></sn-icon>
        </button>
      </div>
    </div>
    <div *ngIf="data.marker.getFollowMode()" class="following-msg">Currently Following</div>
    <fs-axon-livestream-iframe
      [device]="data.marker.device"
      [isDocked]="false"
      [marker]="data.marker"
    ></fs-axon-livestream-iframe>
  </div>
</ng-template>
